<script setup lang="ts">
import './assets/style.scss'
import { computed, type PropType, ref, watch, watchEffect } from 'vue'
import { VIcons } from '@/shared/ui'

const props = defineProps({
  list: {
    type: Array as PropType<{ title: string; value: number | string }[]>,
    default: [],
  },
})

const model = defineModel()

const selected = ref<(number | string)[]>([])
const search = ref('')
const open = ref(false)

const filter = ref()
const filterList = ref()

/** Обновляем значение при выборе новых фильтров */
watch(selected, () => {
  model.value = selected.value
})

/** Вычисляем позицию элемента выпадающего списка */
watchEffect(() => {
  if (!filter.value || !filterList.value) return

  const filterRect = filter.value.getBoundingClientRect()
  filterList.value.style.top = filterRect.y + 10 + filterRect.height + 'px'
  filterList.value.style.left = filterRect.x + 'px'
})

/** Вычисляем количество выбранных элементов */
const counter = computed(() => {
  return selected.value.length
})

/** Вычисляем список элементов */
const items = computed(() => {
  const filteredBySearch = props.list.filter((item) =>
    item.title.toLowerCase().includes(search.value.toLowerCase()),
  )

  return [...filteredBySearch].sort((a, b) => {
    const aSelected = selected.value.includes(a.value)
    const bSelected = selected.value.includes(b.value)
    return Number(bSelected) - Number(aSelected)
  })
})
</script>

<template>
  <div class="table-filter" ref="filter">
    <div class="table-filter__title" @click="open = !open">
      <slot />
      <span class="table-filter__counter" v-if="counter">{{ counter }}</span>
      <VIcons
        class="table-filter__arrow"
        :class="{ 'table-filter__arrow__open': open }"
        type="keyboard_arrow_down"
      />
    </div>

    <Teleport to="body">
      <div
        v-if="open"
        ref="filterList"
        class="table-filter__list"
        v-click-outside="() => (open = false)"
      >
        <div class="table-filter__search">
          <VTextField v-model="search" :label="$t('itf.search')" hide-details />
        </div>

        <div class="table-filter__items" v-if="items.length">
          <VCheckbox
            class="table-filter__item"
            v-for="item in items"
            v-model="selected"
            :value="item.value"
            :label="item.title"
            :key="item.value"
            density="compact"
            hide-details
          />
        </div>

        <div class="table-filter__empty" v-else>{{ $t('itf.filter_no_data') }}</div>
      </div>
    </Teleport>
  </div>
</template>
